module.exports = __webpack_public_path__ + "images/giftTree/birthday.d5012b9aaa09890b1f68d8b19ae577f8.png";